/**
 * @generated SignedSource<<fa7a9eec002f62250f44b5e4a65a6b48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
export type WelcomeChecklistTaskCompletionStatus = "COMPLETE" | "INCOMPLETE" | "PENDING_COMPLETION";
import { FragmentRefs } from "relay-runtime";
export type NoteCard_viewer$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
    readonly allowCompleteByAny: boolean;
    readonly allowExternalInviting: boolean | null;
    readonly allowMeetingRecording: boolean;
    readonly allowRecapDownload: boolean;
    readonly billingAccount: {
      readonly featureAccess: any;
      readonly hasAccessToAsana: boolean;
      readonly hasAccessToComments: boolean;
      readonly hasAccessToDuedates: boolean;
      readonly hasAccessToEmbeds: boolean;
      readonly hasAccessToHubspot: boolean;
      readonly hasAccessToJiraIntegration: boolean;
      readonly hasAccessToMeetingFeedback: boolean;
      readonly hasAccessToMultipleAssignees: boolean;
      readonly hasAccessToNoteLocking: boolean;
      readonly hasAccessToObjectives: boolean;
      readonly hasAccessToPromptHeadings: boolean;
      readonly hasAccessToSalesforce: boolean;
      readonly hasAccessToSharing: boolean;
      readonly hasAccessToVersioning: boolean;
    };
    readonly defaultMeetingTemplate: {
      readonly id: string;
      readonly isWhiteListedForTemplateBanner: boolean | null;
    } | null;
    readonly defaultOneononeTemplate: {
      readonly id: string;
      readonly isWhiteListedForTemplateBanner: boolean | null;
    } | null;
    readonly emailDomainList: ReadonlyArray<string>;
    readonly id: string;
    readonly integrations: {
      readonly jira: {
        readonly baseUrl: string;
        readonly clientKey: string;
        readonly id: string;
      } | null;
    };
    readonly isPersonalType: boolean;
    readonly loomEnabled: boolean;
    readonly primaryAdmin: {
      readonly fullName: string;
    } | null;
    readonly tags: ReadonlyArray<{
      readonly __typename: "Tag";
      readonly color: Colors;
      readonly id: string;
      readonly label: string;
    }>;
  };
  readonly calendars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: string | null;
        readonly hadErrorOnSync: boolean | null;
        readonly id: string;
        readonly lastSyncDatetime: string | null;
        readonly name: string | null;
        readonly source: CalendarSource;
        readonly sourcePrimary: boolean;
        readonly syncEnabled: boolean;
      };
    }>;
  };
  readonly canCreateWorkspaceTemplate: boolean;
  readonly connectedActionItemIntegrations: ReadonlyArray<IntegrationProvider>;
  readonly hasAccessToCopilot: boolean;
  readonly integrations: {
    readonly asana: {
      readonly isConnected: boolean;
    } | null;
    readonly zoom: {
      readonly hasLocalRecordingTokenScope: boolean;
    } | null;
  };
  readonly lastUsedBrowserExtension: string | null;
  readonly lastUsedZoomApp: string | null;
  readonly remainingMeetingRecordingCredits: number;
  readonly settings: {
    readonly automaticallyWatchNotestreams: boolean | null;
    readonly managerDisabled: boolean | null;
  };
  readonly user: {
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly internalAttributes: {
      readonly isAccountAdmin: boolean;
      readonly manager: {
        readonly id: string;
      } | null;
    } | null;
    readonly isGuest: boolean;
    readonly lastName: string;
    readonly type: UserType;
  };
  readonly videoPlaybackSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
  };
  readonly welcomeChecklist: {
    readonly firstAgendaPrepared: WelcomeChecklistTaskCompletionStatus;
  };
  readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer" | "EventFormModal_viewer" | "JoinConferenceButton_viewer" | "LiveReactions_viewer" | "MeetingPhaseContext_viewer" | "MeetingRecordingBanner_viewer" | "NoteAndFeedbackHistoryPaywall_viewer" | "NoteHeader_viewer" | "PreMeetingControls_viewer" | "SendNotesModal_viewer" | "SuggestedActions_viewer" | "TranscriptModal_viewer">;
  readonly " $fragmentType": "NoteCard_viewer";
};
export type NoteCard_viewer$key = {
  readonly " $data"?: NoteCard_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteCard_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isWhiteListedForTemplateBanner",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteCard_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastUsedBrowserExtension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastUsedZoomApp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canCreateWorkspaceTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "connectedActionItemIntegrations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaUserNode",
          "kind": "LinkedField",
          "name": "asana",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConnected",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomUserNode",
          "kind": "LinkedField",
          "name": "zoom",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasLocalRecordingTokenScope",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInternalAttributes",
          "kind": "LinkedField",
          "name": "internalAttributes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountAdmin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "manager",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarConnection",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourcePrimary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "syncEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastSyncDatetime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hadErrorOnSync",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "automaticallyWatchNotestreams",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "managerDisabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToDuedates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "duedates"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"duedates\")"
            },
            {
              "alias": "hasAccessToVersioning",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "versioning"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"versioning\")"
            },
            {
              "alias": "hasAccessToSharing",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "sharing"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"sharing\")"
            },
            {
              "alias": "hasAccessToJiraIntegration",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "jira_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"jira_integration\")"
            },
            {
              "alias": "hasAccessToComments",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "comments"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"comments\")"
            },
            {
              "alias": "hasAccessToMeetingFeedback",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "meeting_feedback"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"meeting_feedback\")"
            },
            {
              "alias": "hasAccessToNoteLocking",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "note_locking"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"note_locking\")"
            },
            {
              "alias": "hasAccessToEmbeds",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "embeds"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"embeds\")"
            },
            {
              "alias": "hasAccessToSalesforce",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "salesforce_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
            },
            {
              "alias": "hasAccessToHubspot",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "hubspot_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
            },
            {
              "alias": "hasAccessToAsana",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "asana_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"asana_integration\")"
            },
            {
              "alias": "hasAccessToObjectives",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "objectives"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"objectives\")"
            },
            {
              "alias": "hasAccessToPromptHeadings",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "prompt_headings"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
            },
            {
              "alias": "hasAccessToMultipleAssignees",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "multiple_assignees"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"multiple_assignees\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "featureAccess",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraAccountNode",
              "kind": "LinkedField",
              "name": "jira",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clientKey",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "baseUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPersonalType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailDomainList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loomEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowExternalInviting",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowCompleteByAny",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowMeetingRecording",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapDownload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "primaryAdmin",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteTemplateNode",
          "kind": "LinkedField",
          "name": "defaultMeetingTemplate",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteTemplateNode",
          "kind": "LinkedField",
          "name": "defaultOneononeTemplate",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WelcomeChecklist",
      "kind": "LinkedField",
      "name": "welcomeChecklist",
      "plural": false,
      "selections": [
        {
          "alias": "firstAgendaPrepared",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "FIRST_AGENDA_PREPARED"
            }
          ],
          "kind": "ScalarField",
          "name": "task",
          "storageKey": "task(key:\"FIRST_AGENDA_PREPARED\")"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreMeetingControls_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteHeader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventFormModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteAndFeedbackHistoryPaywall_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingIdentityFeaturesPaywall_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SendNotesModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingRecordingBanner_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingPhaseContext_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SuggestedActions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JoinConferenceButton_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LiveReactions_viewer"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "isPublic",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "TranscriptModal_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserVideoPlaybackSettings",
      "kind": "LinkedField",
      "name": "videoPlaybackSettings",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranscriptVideo_videoPlaybackSettings"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7b8dee662f787cfa27463b7923e26f08";

export default node;
